













































































import {Component, Vue, Watch} from 'vue-property-decorator';
import GameVideo from '@/components/GameVideo.vue';
import {QUESTION_LIST} from './storage/questionList';
import {VideoQuestion} from '@/interfaces';
import GameTimer from '@/components/GameTimer.vue';
import AppFooter from '@/components/AppFooter.vue';

@Component({
    components: {
        AppFooter,
        GameTimer,
        GameVideo,
    },
})
export default class App extends Vue {
    protected indexOfCurrentQuestion: number = 0;
    protected indexesOfQuestionsUsed: number[] = [];
    protected readonly TIME_PER_QUESTION: number = 25;
    protected secondsRemaining: number = this.TIME_PER_QUESTION;
    protected readonly videoPlayerSize: number = 350;
    protected randomJumpInterval: any;

    protected message: string = `Can you guess the song?
    Audio will be played at random speeds and random points.
    You'll have ${this.TIME_PER_QUESTION} seconds to guess!`;

    protected gameHasStarted: boolean = false;

    protected movieAnswer: string = '';
    protected songAnswer: string = '';
    protected playerPoints: number = 0;

    @Watch('videoPlayerSize')
    protected onVideoPlayerSizeChanged(): void {
        document.documentElement.style.setProperty('--video-size', `${this.videoPlayerSize}px`);
    }

    protected created(): void {
        this.onVideoPlayerSizeChanged();
    }

    protected async onError(): Promise<void> {
        await this.playNextQuestion();
    }

    protected async playNextQuestion(): Promise<void> {
        this.gameHasStarted = true;
        this.message = 'Loading Question...';

        this.songAnswer = '';
        this.movieAnswer = '';
        this.timer.stop();
        this.secondsRemaining = this.TIME_PER_QUESTION;

        this.selectNextQuestion();

        await this.gameVideo.startQuestion(this.currentQuestion);

        if (this.randomJumpInterval) {
            clearInterval(this.randomJumpInterval);
        }

        this.randomJumpInterval = setInterval( async () => {
            await this.gameVideo.playRandomPoint();
        }, 5000);

        setTimeout(() => this.timer.start(), 1500);
    }

    protected selectNextQuestion(): void {
        this.indexOfCurrentQuestion = 0;

        do {
            this.indexOfCurrentQuestion = Math.floor(Math.random() * QUESTION_LIST.length);
        } while (this.indexesOfQuestionsUsed.includes(this.indexOfCurrentQuestion));
        this.indexesOfQuestionsUsed.push(this.indexOfCurrentQuestion);

        if (this.indexesOfQuestionsUsed.length === QUESTION_LIST.length) {
            this.indexesOfQuestionsUsed = [];
        }
    }

    protected async revealAnswer(): Promise<void> {
        clearInterval(this.randomJumpInterval);

        if (this.movieIsRight) {
            this.playerPoints += 2;
        }

        if (this.songIsRight) {
            this.playerPoints += 3;
        }

        this.message = (this.movieIsRight && this.songIsRight)
            ? 'Perfect! Well Done!'
            : this.movieIsRight || this.songIsRight
                ? 'Good!'
                : 'Sorry! Better luck next time!';

        await this.gameVideo.reveal();

        await this.playNextQuestion();
    }

    protected get diameterOfTimer(): number {
        return Math.round(this.videoPlayerSize * 0.65);
    }

    protected skipToAnswer(): void {
        if (this.secondsRemaining > 3) {
            this.secondsRemaining = 3;
        }
    }

    protected get canSkip(): boolean {
        return this.secondsRemaining > 3 && this.secondsElapsed > 3;
    }

    protected get currentQuestion(): VideoQuestion {
        return QUESTION_LIST[this.indexOfCurrentQuestion];
    }

    protected get movieIsRight(): boolean {
        return this.movieAnswer === this.currentQuestion.movie;
    }

    protected get songIsRight(): boolean {
        return this.songAnswer === this.currentQuestion.song;
    }

    protected get secondsElapsed(): number {
        return this.TIME_PER_QUESTION - this.secondsRemaining;
    }

    protected get movies(): string[] {
        return QUESTION_LIST.map((question: VideoQuestion) => question.movie).sort();
    }

    protected get songs(): string[] {
        return QUESTION_LIST.map((question: VideoQuestion) => question.song).sort();
    }

    protected get messageColourClass(): string {
        if (this.secondsRemaining === 0) {
            return (this.movieIsRight || this.songIsRight) ? 'green--text text--darken-1' : 'red--text';
        }

        return 'light-blue--text text--darken-4';
    }

    protected get gameVideo(): GameVideo {
        // @ts-ignore
        return this.$refs.gameVideo;
    }

    protected get timer(): GameTimer {
        // @ts-ignore
        return this.$refs.timer;
    }
}
